import { Loader } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// native: 'dproz://redirect',

function LinkedInApp() {
	const [isLoading, setIsLoading] = useState(true);

	const queryParams = new URLSearchParams(window.location.search);
	const code = queryParams.get("code");

	const navigate = useNavigate();

	useEffect(() => {
		const fetchLinkedInData = async () => {
			if (code) {
				const redirectUrl = `dproz://redirect?code=${encodeURIComponent(code)}`;
				window.location.href = redirectUrl;
			} else {
				toast.error("LinkedIn login failed");
				navigate("/signin");
			}
			setIsLoading(false);
		};

		fetchLinkedInData();
	}, [code]);

	return <div className="hidden">{isLoading ? <Loader /> : null}</div>;
}

export default LinkedInApp;
